import React from 'react'
import errorImg from '../assets/images/error400-cover.png'

/**
 * Error404 component displays a custom 404 error page when the requested page is not found.
 *
 * This component includes styles and meta tags necessary for displaying a 404 error page. It uses the `react-helmet`
 * library to include external CSS files and displays an image and message indicating that the page is not available.
 *
 * @module common/Error404
 * @description Error404 component displays a custom 404 error page when the requested page is not found.
 *
 * This component includes styles and meta tags necessary for displaying a 404 error page. It uses the `react-helmet`
 * library to include external CSS files and displays an image and message indicating that the page is not available.
 *
 * @example
 * return (
 *   <Error404 />
 * );
 *
 * @returns {React.Element} Renders a 404 error page with a message and a link to navigate back to the home page.
 */
export const Error404 = () => {
  return (
    <div className="trtui-auth-page-wrapper trtui-pb-5 trtui-d-flex trtui-justify-content-center trtui-align-items-center trtui-min-vh-100">
      <div className="trtui-auth-page-content trtui-overflow-hidden trtui-p-0">
        <div className="trtui-container-fluid">
          <div className="trtui-row trtui-justify-content-center">
            <div className="trtui-col-xl-4 trtui-text-center">
              <div className="trtui-error-500 trtui-position-relative">
                <img
                  src={errorImg}
                  alt="Error 404"
                  className="trtui-img-fluid trtui-error-500-img trtui-error-img"
                  data-testid="error404image"
                />
                <h1 className="trtui-title trtui-text-muted">&nbsp;</h1>
              </div>
              <div>
                <h4>SORRY, PAGE NOT FOUND 😭</h4>
                <p>The page you are looking for is not available!</p>
                <a href="/" className="trtui-btn trtui-btn-secondary trtui-text-white">
                  <i className="mdi mdi-home trtui-me-1" /> Back To Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
